import React, { ReactNode } from "react";

interface IProps {
  children?: ReactNode;
  index: number | string;
  value: number | string;
}

const TabPanel: React.FC<IProps> = ({ children, value, index }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`tabpanel-${index}`}
    aria-labelledby={`tab-${index}`}
    style={{ width: "100%" }}
  >
    {value === index && children}
  </div>
);

export default TabPanel;
